@if (!$galleryImages()) {
  <p-image
    [src]="'/assets/images/misc/placeholder/product-placeholder.png'"
    [alt]="'Placeholder product image'"
    class="-placeholder"
  >
  </p-image>
}
@if ($galleryImages() && $galleryImages().length === 1) {
  <p-image
    [src]="$galleryImages()[0].itemImageSrc"
    [preview]="true"
    [alt]="$galleryImages()[0].alt"
  >
    <ng-template #image>
      <div class="galleria-item-container">
        <img
          [src]="$galleryImages()[0].itemImageSrc"
          [alt]="$galleryImages()[0].alt"
          [sizes]="
            '(min-width: 576px) 333px, ' +
            '(min-width: 992px) 444px, ' +
            '250px'
          "
        />
      </div>
    </ng-template>
    <ng-template
      #preview
      let-style="style"
      let-previewCallback="previewCallback"
    >
      <div class="galleria-item-zoom-container">
        <img
          [src]="$galleryImages()[0].zoomImageSrc"
          [alt]="$galleryImages()[0].alt"
          [style]="style"
          (click)="previewCallback()"
        />
      </div>
    </ng-template>
  </p-image>
}

@if ($galleryImages() && $galleryImages().length > 1) {
  <p-galleria
    [value]="$galleryImages()"
    [responsiveOptions]="responsiveOptions"
    [showThumbnails]="true"
    [showThumbnailNavigators]="true"
    [circular]="true"
    [(activeIndex)]="$activeIndex"
    [visible]="!$zoomVisible()"
    class="-default"
  >
    <ng-template #item let-item>
      <div class="galleria-item-container">
        <img
          [src]="item.itemImageSrc"
          (click)="openZoomModal()"
          (keyup.enter)="openZoomModal()"
          tabindex="0"
          [sizes]="
            '(min-width: 576px) 333px, ' +
            '(min-width: 992px) 444px, ' +
            '250px'
          "
        />
      </div>
    </ng-template>
    <ng-template #thumbnail let-item>
      <div class="galleria-thumbnail-container">
        <img [src]="item.thumbnailImageSrc" />
      </div>
    </ng-template>
  </p-galleria>

  @if ($zoomVisible()) {
    <p-galleria
      [value]="$galleryImages()"
      [circular]="true"
      [fullScreen]="$zoomVisible"
      [visible]="$zoomVisible()"
      (visibleChange)="closeZoomModal()"
      [(activeIndex)]="$zoomActiveIndex"
      [responsiveOptions]="responsiveOptions"
      class="-zoom"
    >
      <ng-template #item let-item>
        <div class="galleria-item-zoom-container">
          <img [src]="item.zoomImageSrc" (click)="openZoomModal()" />
        </div>
      </ng-template>
      <ng-template #thumbnail let-item>
        <div class="galleria-thumbnail-container">
          <img [src]="item.thumbnailImageSrc" />
        </div>
      </ng-template>
    </p-galleria>
  }
}
